<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <visitor-check-out-page /><br><br><br>
    </div>
  </div>
</template>

  <script>
  import VisitorCheckOutPage from '../../../Components/Visitor/VisitorCheckOutPage.vue';
    export default {
      name: 'VisitorCheckInPage',
      components: {
        'visitor-check-out-page': VisitorCheckOutPage,
    },
  };
  </script>

  <style scoped>

  </style>
